import React, {useEffect, useRef} from 'react';
import {Typography, Box} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CloseIcon from '@mui/icons-material/Close';
import ArrMenu, {ArrMenuHandle, CustomMenuItem} from '../arr-menu/ArrMenu';
import ArrIconButton from '../arr-icon-button/ArrIconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {OutPortal, type HtmlPortalNode} from 'react-reverse-portal';
import './ArrPopoutPanel.scss';

interface RenderComponentWrapperProps {
  portalNode: HtmlPortalNode;
  title: string;
  onPopout: () => void;
  onActionMenu: () => void;
  isPopoutOpen: boolean;
  actionMenuItems?: CustomMenuItem[];
}

// ----------------------------------
// RenderComponentWrapper Component
// ----------------------------------
const RenderComponentWrapper: React.FC<RenderComponentWrapperProps> = ({
  portalNode,
  title = 'Popout Window',
  onPopout,
  onActionMenu,
  isPopoutOpen,
  actionMenuItems = [],
  ...props
}) => {
  const menuRef = useRef<ArrMenuHandle | null>(null);
  const menuIconRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (menuRef.current) {
      menuRef.current.open(menuIconRef.current as HTMLElement, false);
      setTimeout(() => menuRef.current?.close(), 100);
    }
  }, []);
  // ------------------

  const onButtonClick1 = (e: React.MouseEvent<HTMLElement>) => {
    menuRef.current?.open(e.currentTarget as HTMLElement);

    if (onActionMenu) {
      onActionMenu();
    }
  };
  // ------------------

  const onItemClick = (item: CustomMenuItem) => {
    item.onClick?.();
  };
  // ------------------

  return (
    <Box className="arr-popout-panel" {...props} data-testid="arr-popout-panel">
      <Box
        className="arr-popout-panel__title-bar"
        data-testid="arr-popout-title-bar"
      >
        <Typography
          className="typo-text subhead5_size arr-popout-panel__title"
          data-testid="arr-popout-title"
        >
          {title}
        </Typography>

        {actionMenuItems && (
          <>
            <ArrMenu
              id="arr-menu-1"
              ref={menuRef}
              items={actionMenuItems}
              onItemClick={onItemClick}
              direction="bottom-left"
              data-testid="arr-action-menu"
            />
            <ArrIconButton
              onClick={onButtonClick1}
              size="medium"
              shape="default"
              ref={menuIconRef}
              icon={<MoreVertIcon />}
              ariaLabel="menu-icon"
              className="arr-popout-panel__menu-icon"
              data-testid="arr-action-menu-icon"
              testId="render-component-wrapper-menu-icon-icon-button" />
          </>
        )}
        <ArrIconButton
          size="medium"
          shape="default"
          icon={isPopoutOpen ? <CloseIcon /> : <OpenInNewIcon />}
          ariaLabel="popout-icon"
          className="arr-popout-panel__menu-icon"
          onClick={onPopout}
          data-testid="arr-popout-icon"
          testId="render-component-wrapper-popout-icon-icon-button" />
      </Box>
      <OutPortal node={portalNode} />
    </Box>
  );
};

export {RenderComponentWrapper};
export default RenderComponentWrapper;
